import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const RadioButton = Styled(
  createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path
        fill="currentColor"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 12 20zm0-3a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
        opacity="1"
      ></path>
    </svg>,
    "RadioButton",
  ),
);

export default RadioButton;
